import React from "react"
import { Badge } from "src/components/ui/badge"

// Status palette shared by the availability grid legend and badges.
// Colors use inline styles because Tailwind v4's scanner misses classes
// that only appear inside JS object literals.
export const UNIT_STATUS_STYLES = {
  available: {
    label: "Available",
    swatchColor: "#34d399",
    badgeStyle: { backgroundColor: "#d1fae5", color: "#047857" },
    cellStyle: { backgroundColor: "#ecfdf5", borderColor: "#a7f3d0", color: "#065f46" },
    cellHover: "#d1fae5",
  },
  blocked: {
    label: "Blocked",
    swatchColor: "#fbbf24",
    badgeStyle: { backgroundColor: "#fef3c7", color: "#b45309" },
    cellStyle: { backgroundColor: "#fffbeb", borderColor: "#fde68a", color: "#92400e" },
    cellHover: "#fef3c7",
  },
  booked: {
    label: "Booked",
    swatchColor: "#38bdf8",
    badgeStyle: { backgroundColor: "#e0f2fe", color: "#0369a1" },
    cellStyle: { backgroundColor: "#f0f9ff", borderColor: "#bae6fd", color: "#075985" },
    cellHover: "#e0f2fe",
  },
  sold: {
    label: "Sold",
    swatchColor: "#94a3b8",
    badgeStyle: { backgroundColor: "#e2e8f0", color: "#334155" },
    cellStyle: { backgroundColor: "#f1f5f9", borderColor: "#cbd5e1", color: "#475569" },
    cellHover: "#e2e8f0",
  },
}

export function UnitStatusBadge({ status, className = "" }) {
  if (!status) return null
  const style = UNIT_STATUS_STYLES[status] || UNIT_STATUS_STYLES.available
  return (
    <Badge
      variant="secondary"
      className={`font-medium px-2 py-0.5 text-xs ${className}`}
      style={style.badgeStyle}
    >
      {style.label}
    </Badge>
  )
}
